import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb", true)!

  return (_openBlock(), _createBlock(_component_Breadcrumb, {
    home: _ctx.home,
    model: _ctx.items,
    class: "custom-breadcrumb"
  }, {
    item: _withCtx(({ item }) => [
      _createElementVNode("span", {
        onClick: item?.command,
        class: _normalizeClass(`${
          item?.command
            ? 'cursor-pointer hover:text-h-secondary-700 transition-all font-bold'
            : 'cursor-default'
        } capitalize`)
      }, _toDisplayString(item.label), 11, _hoisted_1)
    ]),
    _: 1
  }, 8, ["home", "model"]))
}